export const TICKETING_SELECTION_V2_RATE_ID_PREFIX = "ticketing-selection-v2-rate-";

export const getRateTileId = (rateId: string): string => `${TICKETING_SELECTION_V2_RATE_ID_PREFIX}${rateId}`;
